import React, { Component } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/esm/FormControl';
import "./VehicleGeneralSearch.css"

interface VehicleGeneralSearchProps {
    input: string,
    placeholder: string,
    handleChange: any,
    clearInput: any,
    handSubmit: Function
}

class VehicleGeneralSearch extends Component<VehicleGeneralSearchProps>{

    render() {

        return (
            <div className="VehicleGeneralSearch" id="vehicle-search-wrapper">
                <InputGroup className="mb-3">
                    <div className="VehicleSearchClear">
                        {this.props.input.length > 0 && <InputGroup.Prepend>
                            <InputGroup.Text id="general-search-clear" onClick={() => this.props.clearInput()}><span className="material-icons">close</span></InputGroup.Text>
                        </InputGroup.Prepend>}
                    </div>
                    <div className="VehicleSearchSearch" id="vehicle-search-search">
                        {this.props.input.length === 0 && <InputGroup.Prepend>
                            <InputGroup.Text id="basic-addon1"><span className="material-icons">search</span>
                            </InputGroup.Text>
                        </InputGroup.Prepend>}
                    </div>
                    <FormControl /*onClick={() => this.props.toggleAdvancedSearch('off')}*/
                        placeholder={this.props.placeholder}
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        onChange={this.props.handleChange}
                        value={this.props.input}
                    />
                </InputGroup>
                {this.props.input.length > 0 && <div id="vehicle-general-search-search-btn" onClick={() => this.props.handSubmit()}>
                    <InputGroup.Prepend>
                        <InputGroup.Text id="basic-addon1"><span className="material-icons">search</span>
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                </div>}
            </div>
        )
    }
}

export default VehicleGeneralSearch